export const captchaSitekey = 'FCMG8QCUL05AOSUC'
export const puzzleEndpoint = 'https://eu-api.friendlycaptcha.eu/api/v1/puzzle'
